var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useI18n } from '@cta-portal/webapp-common/lib/hooks/translations/use-i18n';
import React from 'react';
import styled from 'styled-components';
export default function AcceptTermsInput(_a) {
    var acceptTerms = _a.acceptTerms, setAcceptTerms = _a.setAcceptTerms;
    var t = useI18n().t;
    return (_jsxs(Container, { children: [_jsx("input", { checked: acceptTerms, onChange: function (event) { return setAcceptTerms(event.target.checked); }, type: "checkbox" }), _jsx("p", { children: t('staking.accept-terms') })] }));
}
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  align-items: center;\n  display: flex;\n  flex-direction: row;\n  gap: 16px;\n  justify-content: flex-start;\n  width: 100%;\n\n  & > input {\n    accent-color: ", ";\n    color: #ffffff;\n    height: 16px;\n    width: 16px;\n  }\n\n  & > p {\n    color: ", ";\n    font-size: 14px;\n    width: calc(100% - 32px);\n  }\n"], ["\n  align-items: center;\n  display: flex;\n  flex-direction: row;\n  gap: 16px;\n  justify-content: flex-start;\n  width: 100%;\n\n  & > input {\n    accent-color: ", ";\n    color: #ffffff;\n    height: 16px;\n    width: 16px;\n  }\n\n  & > p {\n    color: ", ";\n    font-size: 14px;\n    width: calc(100% - 32px);\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.palette.gold;
}, function (_a) {
    var theme = _a.theme;
    return theme.palette.gold;
});
var templateObject_1;
